<!-- <ion-row>
  <ion-col size="12" text-center>
    <div>
        <p class="sub-header program-name">Program: {{application.name}}</p>
        <p class="sub-header">First Day Checklist</p>
    </div>
  </ion-col>
</ion-row> -->

<ion-row>
    <ion-col size="12">
        <div>
            <ion-card class="card-1 list-card grey-background" style="margin-bottom: 1em">
                <div>
                    <div *ngIf="showPreDepartureRegistration" class="card-header">
                        <ion-label *ngIf="existingPreDepartureOrientation" class="section-title" color="dark-teal"> Attend Your Orientation </ion-label>
                        <ion-label *ngIf="!existingPreDepartureOrientation" class="section-title" color="dark-teal"> Register for Orientation </ion-label>
                    </div>
                    <div *ngIf="showPreDepartureRegistration">
                        <ion-card-content>
                            <div *ngIf="!existingPreDepartureOrientation" class="ion-text-center">
                                <br />
                                <ion-select
                                    ok-text="Register"
                                    [interfaceOptions]="orientationAlertOptions"
                                    placeholder="Select Date"
                                    class="orientation-select basic-select"
                                    [(ngModel)]="preDepartureSelection"
                                    (ionChange)="preDepartureConferenceSelected($event)"
                                >
                                    <ion-select-option *ngFor="let conference of orientations?.predepartureschedule" [value]="conference">
                                        {{ conference?.datetime | date: 'mediumDate' }} {{ conference?.datetime | date: 'shortTime' }}
                                    </ion-select-option>
                                </ion-select>
                            </div>
                            <div *ngIf="existingPreDepartureOrientation" class="ion-text-center">
                                <ion-text>
                                    <p *ngIf="!existingPreDepartureOrientation?.recordingurl">
                                        Your Orientation starts {{ existingPreDepartureOrientation?.datetime | date: 'long' }}
                                    </p>
                                    <p *ngIf="existingPreDepartureOrientation?.recordingurl">
                                        Please view the orientation below important information regarding your requirements and tips for preparing for your AMO
                                        Clinical Experience
                                    </p>
                                    <br />
                                    <ion-button
                                        *ngIf="!existingPreDepartureOrientation?.recordingurl"
                                        href="{{ existingPreDepartureOrientation?.url }}"
                                        target="_blank"
                                        expand="full"
                                        color="primary"
                                        class="btn-width"
                                    >
                                        <ion-text class="ion-text-wrap bold"> View my Orientation </ion-text>
                                    </ion-button>
                                    <ion-button
                                        *ngIf="existingPreDepartureOrientation?.recordingurl"
                                        href="{{ existingPreDepartureOrientation?.recordingurl }}"
                                        target="_blank"
                                        color="secondary"
                                        expand="full"
                                        class="btn-width"
                                    >
                                        <ion-text class="ion-text-wrap bold"> View Orientation Recording </ion-text>
                                    </ion-button>
                                    <ion-button type="button" fill="clear" class="btn-link-text" (click)="preDepartureChange()">
                                        <ion-text class="ion-text-wrap bold"> Change my date. </ion-text>
                                    </ion-button>
                                </ion-text>
                            </div>
                        </ion-card-content>
                    </div>
                </div>
            </ion-card>
            <ion-card class="card-1 list-card" style="margin-bottom: 1em">
                <div>
                    <div class="card-header">
                        <ion-label class="section-title" color="secondary">
                            <fa-icon [icon]="icons.tasks"></fa-icon>
                            Before your first day:
                        </ion-label>
                    </div>
                </div>
                <ion-card-content>
                    <ion-text class="card-text text-teal">
                        <p>
                            {{ content?.beforeFirstDay?.cardDescription }}
                        </p>
                    </ion-text>
                    <div class="note-card-container">
                        <ion-card class="note-card">
                            <div>
                                <div class="card-header">
                                    <ion-label class="seat-text" color="secondary">
                                        <fa-icon [icon]="icons.exclamation"></fa-icon>
                                        Your Reporting Information
                                    </ion-label>
                                </div>
                            </div>
                            <ion-text class="text-block">
                                <div class="text-block">
                                    <div class="dark-blue note-text">
                                        <div class="bold-text inline">Reporting Location:</div>
                                        {{ application?.program?.address }}, {{ application?.program?.city }}, {{ application?.program?.state }}
                                        {{ application?.program?.postalcode }}
                                    </div>
                                    <br />
                                    <div class="dark-blue note-text">
                                        <div class="bold-text inline">Reporting Date:</div>
                                        {{ application?.startdate | date: 'longDate':'UTC' }}
                                    </div>
                                    <br />
                                    <div class="dark-blue note-text">
                                        <div class="bold-text inline">Reporting Time:</div>
                                        {{ application?.program?.reportingtime }}
                                    </div>
                                </div>
                            </ion-text>
                        </ion-card>
                    </div>
                    <ion-list>
                        <ion-item *ngFor="let question of content?.beforeFirstDay?.checklist" lines="none">
                            <ion-label class="ion-text-wrap">{{ question }}</ion-label>
                            <ion-checkbox slot="start"></ion-checkbox>
                        </ion-item>
                    </ion-list>
                </ion-card-content>
            </ion-card>
        </div>
    </ion-col>
</ion-row>
<ion-row>
    <ion-col size="12">
        <ion-card class="card-1 list-card">
            <div>
                <div class="card-header">
                    <ion-label class="section-title" color="secondary">
                        <fa-icon [icon]="icons.tasks"></fa-icon>
                        On your first day:
                    </ion-label>
                </div>
            </div>
            <ion-card-content>
                <ion-text color="text">
                    <p class="card-text">
                        {{ content?.onFirstDay?.cardDescription }}
                    </p>
                </ion-text>
                <ion-list>
                    <ion-item *ngFor="let question of content?.onFirstDay?.checklist" lines="none">
                        <ion-label class="ion-text-wrap">{{ question }}</ion-label>
                        <ion-checkbox slot="start"></ion-checkbox>
                    </ion-item>
                </ion-list>
            </ion-card-content>
        </ion-card>
    </ion-col>
</ion-row>
